import classNames from 'classnames';
import { ApplicationState } from '../../../utils/enums';
import { ActionIcon, FavouriteIcon } from '@tymbe/ui-icons';
import { ApplicationData } from '../../../types/TymbeApi';
import { JSX } from 'react';
import moment from 'moment';

const TymberAppStateIcon = ({ application }: TymberAppStateIconProps) => {
  let tymberApplicationState: TymberApplicationStateKeys;

  switch (application.state) {
    case ApplicationState.CONFIRMED:
      tymberApplicationState = TymberApplicationStateKeys.confirmed;
      break;
    case ApplicationState.REJECTED:
    case ApplicationState.SYSTEM_CANCELED:
    case ApplicationState.CANCELED_EARLY:
    case ApplicationState.CANCELED_LATE:
    case ApplicationState.CANCELED:
      tymberApplicationState = TymberApplicationStateKeys.rejected;
      break;
    case null:
      if (moment(application.deleted_at).isAfter(moment())) {
        tymberApplicationState = TymberApplicationStateKeys.invited;
      } else {
        tymberApplicationState = TymberApplicationStateKeys.inviteExpired;
      }
  }
  return (
    <div
      className={classNames(
        'flex justify-center items-center size-2.5 border-[1.5px] border-bg rounded-full absolute -right-1 -bottom-1 box-content',
        TymberApplicationStates[tymberApplicationState!].bg,
      )}
    >
      {TymberApplicationStates[tymberApplicationState!].icon}
    </div>
  );
};

export default TymberAppStateIcon;


interface TymberAppStateIconProps {
  application: ApplicationData;
}

enum TymberApplicationStateKeys {
  confirmed,
  rejected,
  invited,
  inviteExpired,
}

type TymberApplicationStateValues = {
  [key in TymberApplicationStateKeys]: { bg: string; icon: JSX.Element };
};

const TymberApplicationStates: TymberApplicationStateValues = {
  [TymberApplicationStateKeys.confirmed]: {
    bg: 'bg-green-700',
    icon: <FavouriteIcon name="check" className="size-2" />,
  },
  [TymberApplicationStateKeys.rejected]: {
    bg: 'bg-red-700',
    icon: <FavouriteIcon name="close" className="size-2" />,
  },
  [TymberApplicationStateKeys.invited]: {
    bg: 'bg-secondary-600',
    icon: <ActionIcon name="question_mark" className="size-2" />,
  },
  [TymberApplicationStateKeys.inviteExpired]: {
    bg: 'bg-orange-500',
    icon: <FavouriteIcon name="close" className="size-2" />,
  },
};